import { useEffect } from 'react'

declare global {
  interface Window {
    InsiderQueue: Array<{ type: string } & Record<string, any>>
  }
}

interface Props {
  searchTerm?: string
  collectionName?: string
}

const InsiderEventCategory = ({ searchTerm, collectionName }: Props) => {
  const searchTitleValue = searchTerm ?? collectionName

  useEffect(() => {
    window.InsiderQueue = window.InsiderQueue || []
    window.InsiderQueue.push({ type: 'category', value: [searchTitleValue] })
    window.InsiderQueue.push({ type: 'init' })
  }, [])

  return null
}

export default InsiderEventCategory
